module.exports = __webpack_public_path__ + "posture/static/img/side.c55d6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/side.png
// module id = YRIN
// module chunks = 1